<template>
    <div class="file-download">
        <div v-if="typeof seqNo == 'number' && seqNo > 0" class="fileseq">{{ seqNo }}</div>
        <label class="filename" name="fileName">{{ loadFileName || '未命名文件' }}</label>
        <div class="stateinfo ml5 mr5 fr">
            <i v-show="loadState == 0" :class="{'clickable' : clickable}" class="icon iconfont icon-xiajia" @click="doClickDownload"></i>
            <img v-show="loadState == 1" style="width:16px;height:16px;" class="icon-loading" v-resc-url="'/image/loading.gif'"/>
            <i v-show="loadState == 2" class="icon iconfont icon-success"></i>
            <i v-show="loadState == -1" class="icon iconfont icon-error"></i>
        </div>
        <div class="loadinfo fr" name="loadInfo">
            <label v-show="loadState==1">{{ loadedBytes || '--' }}/</label><label>{{ totalBytes || '--' }}</label>
        </div>
        <div v-if="seqNo <= 0 && xlsExport== true" style="position: absolute; margin-top:10px;">
            <el-checkbox style="color:navy;" v-model="valueAsNormalFormats">按常规格式输出数据</el-checkbox>
        </div>
    </div>
</template>

<script>
    import { Utils, H5file } from '../../app.base'
    import { Vue } from '../../app.vues'
    //
    //用M/K表示文件大小
    const SIZE_K = 1024;
    const SIZE_M = SIZE_K * SIZE_K;

    function toFileSizeStr(fileSize) {
        if(fileSize == null) {
            return null;
        }
        if(fileSize >= SIZE_M) {
            return (Math.round(fileSize / SIZE_M * 100) / 100) + 'm';
        }
        else {
            return (Math.round(fileSize / SIZE_K * 100) / 100) + 'k';
        }
    }

    export default {
        name: 'swb-file-download',
        desc: 'Ajax文件下载',
        props: {
            seqNo: {//按组下载时（从1开始）
                type: Number,
                default: -1
            },
            post: {//是否以post方式下载
                type: Boolean,
                default: false
            },
            url: {//下载url
                type: String
            },
            header: {//请求头，json格式
                type: Object
            },
            params: {//url参数，json格式
                type: Object
            },
            data: {//post数据，json格式
                type: Object
            },
            asForm: {//post形式（是否以表单形式提交，默认为json形式）
                type: Boolean,
                default: false
            },
            fileName: {//下载文件名称（优先从Response头中的Content-Disposition:...中解析）
                type: String,
                default: null
            },
            fileNameHeader: {//自定义文件名Response头名称
                type: String,
                default: null
            },
            timeout: {//请求超时时间（毫秒）
                type: Number
            },
            clickable: {//是否可主动点击下载
                type: Boolean,
                default: true
            },
            tag: {//自定义对象，下载结束后传回
                type: Object
            },
            onStarted: {//下载开始 {seqNo}
                type: Function
            },
            // onProgress:  //{type : (0,开始，1:进行中，2:结束，-1:中止), message, fileName, loaded, total}
            // onDone:  //result(data : {fileName, fileBody})
            // onFail: //result
            onResult: {//{type : info/warn/error, message, tag, fileName[, seqNo]}
                type: Function
            },
            xlsExport: {//是否纯xls导出（从而支持“按常规格式输出”选项）
                type: Boolean,
                default: false
            },
            //
            autoDownload: {//是否自动下载（仅首次有效）
                type: Boolean,
                default: false
            }
        },

        watch: {
            post(val, oldValue) {
                if(this.loadState == 1) {
                    console.warn('下载过程中不能变更下载信息');
                    return;
                }
                //
                this.infoVer++;
                this.loadState = 0;
                //
                console.log('post :: ' + oldValue + " -> " + val);
                //
                if(this.post) {
                    this.$fileDownloader.post(this.url);
                }
                else {
                    this.$fileDownloader.get(this.url);
                }
            },
            url(val, oldValue) {
                if(this.loadState == 1) {
                    console.warn('下载过程中不能变更下载信息');
                    return;
                }
                //
                this.infoVer++;
                this.loadState = 0;
                //
                console.log('url :: ' + oldValue + " -> " + val);
                //
                if(this.post) {
                    this.$fileDownloader.post(this.url);
                }
                else {
                    this.$fileDownloader.get(this.url);
                }
                //重置文件名
                if(!this.fileName) {//未设置文件名
                    let reqUrl = this.url;
                    if(reqUrl.endsWith('?')) {
                        reqUrl = reqUrl.substring(0, reqUrl.length - 1);
                    }
                    this.loadFileName = Utils.extractShortFileName(reqUrl);
                    this.$fileDownloader.fileName(null);
                }
            },
            header(val, oldValue) {
                if(this.loadState == 1) {
                    console.warn('下载过程中不能变更下载信息');
                    return;
                }
                //
                this.infoVer++;
                this.loadState = 0;
                //
                console.log('header :: ' + oldValue + " -> " + val);
                //
                if(this.header) {
                    this.$fileDownloader.header(this.header);
                }
            },
            params(val, oldValue) {
                if(this.loadState == 1) {
                    console.warn('下载过程中不能变更下载信息');
                    return;
                }
                //
                this.infoVer++;
                this.loadState = 0;
                //
                console.log('params :: ' + oldValue + " -> " + val);
                //
                let params = this.params || {};
                if(this.valueAsNormalFormats == true) {
                    params['valueAsNormalFormats'] = true;
                }
                this.$fileDownloader.params(params);
            },
            data(val, oldValue) {
                if(this.loadState == 1) {
                    console.warn('下载过程中不能变更下载信息');
                    return;
                }
                //
                this.infoVer++;
                this.loadState = 0;
                //
                console.log('data :: ' + oldValue + " -> " + val);
                //
                if(this.data) {
                    this.$fileDownloader.data(this.data);
                }
            },
            fileName(val, oldValue) {
                if(this.loadState == 1) {
                    console.warn('下载过程中不能变更下载信息');
                    return;
                }
                //
                this.infoVer++;
                this.loadState = 0;
                //
                console.log('fileName :: ' + oldValue + " -> " + val);
                //重置文件名
                if(this.fileName) {
                    this.loadFileName = this.fileName;
                    this.$fileDownloader.fileName(this.fileName);
                }
                else {//未设置文件名
                    let reqUrl = this.url;
                    if(reqUrl.endsWith('?')) {
                        reqUrl = reqUrl.substring(0, reqUrl.length - 1);
                    }
                    this.loadFileName = Utils.extractShortFileName(reqUrl);
                    this.$fileDownloader.fileName(null);
                }
            },
            asForm(val, oldValue) {
                if(this.loadState == 1) {
                    console.warn('下载过程中不能变更下载信息');
                    return;
                }
                //
                this.infoVer++;
                this.loadState = 0;
                //
                console.log('asForm :: ' + oldValue + " -> " + val);
                //
                if(this.asForm) {
                    this.$fileDownloader.asForm();
                }
                else {
                    this.$fileDownloader.asJson();
                }
            }
        },
        data() {
            return {
                $fileDownloader: null,
                //按常规格式输出
                valueAsNormalFormats: false,
                //标记下载信息是否变动过（防止重复下载）
                loadVer: 0,
                infoVer: 0,
                //
                loadFileName: null,//下载文件名（以传入的fileName为基准，但未传入则是自动解析出来的）
                loadedBytes: null,
                totalBytes: null,
                //用于改变下载图标
                loadState: 0
            }
        },
        //
        mounted() {
            let self = this;
            let parent = self.$parent || null;
            //
            this.$fileDownloader = H5file.Downloader.newOne();
            //url
            if(this.post) {
                this.$fileDownloader.post(this.url);
            }
            else {
                this.$fileDownloader.get(this.url);
            }
            //header
            if(this.header) {
                this.$fileDownloader.header(this.header);
            }
            //params
            let params = this.params || {};
            if(this.valueAsNormalFormats == true) {
                params['valueAsNormalFormats'] = true;
            }
            this.$fileDownloader.params(params);
            //data
            if(this.data) {
                this.$fileDownloader.data(this.data);
            }
            //fileName
            if(this.fileName) {
                this.loadFileName = this.fileName;
                this.$fileDownloader.fileName(this.fileName);
            }
            else {//未设置文件名
                let reqUrl = this.url;
                if(reqUrl.endsWith('?')) {
                    reqUrl = reqUrl.substring(0, reqUrl.length - 1);
                }
                this.loadFileName = Utils.extractShortFileName(reqUrl);
                this.$fileDownloader.fileName(null);
            }
            //asForm
            if(this.asForm) {
                this.$fileDownloader.asForm();
            }
            else {
                this.$fileDownloader.asJson();
            }
            //fileNameHeader
            if(this.fileNameHeader) {
                this.$fileDownloader.fileNameHeader(this.fileNameHeader);
            }
            //timeout
            if(this.timeout) {
                this.$fileDownloader.timeout(this.timeout);
            }
            //
            this._resultHanlder = function (result) {
                if(result.type == 'info') {
                    self.totalBytes = self.loadedBytes;
                    self.loadState = 2;//保障最终状态
                    //
                    let data = result.data; //{fileName, fileBody}
                    let fileName = data.fileName;
                    let fileBody = data.fileBody;
                    if(window.navigator && window.navigator.msSaveBlob) { //IE
                        window.navigator.msSaveBlob(new Blob([fileBody]), fileName);
                    }
                    else { //非IE
                        let tmpLink = document.createElement('A');
                        document.body.appendChild(tmpLink);
                        tmpLink.style = 'display: none';
                        let fileUrl = window.URL.createObjectURL(fileBody);
                        tmpLink.href = fileUrl;
                        tmpLink.download = fileName;
                        tmpLink.click();
                        window.URL.revokeObjectURL(tmpLink.href);
                        document.body.removeChild(tmpLink);
                        tmpLink.remove();
                    }
                    //
                    if(self.onResult) {
                        let resultX = {
                            type: 'info',
                            message: fileName + '已下载',
                            fileName: fileName
                        };
                        if(self.tag) {
                            resultX.tag = self.tag;
                        }
                        if(self.seqNo > 0) {
                            resultX.seqNo = self.seqNo;
                        }
                        self.onResult.call(parent, resultX);
                    }
                    else {
                        console.info(result.message);
                    }
                }
                else { //如果设置了failHandler,这一部分不需要
                    self.loadState = -1;//保障最终状态
                    //
                    if(self.onResult) {
                        let resultX = {
                            type: 'warn',
                            message: result.message,
                            fileName: self.loadFileName
                        };
                        if(self.tag) {
                            resultX.tag = self.tag;
                        }
                        if(self.seqNo > 0) {
                            resultX.seqNo = self.seqNo;
                        }
                        self.onResult.call(parent, resultX);
                    }
                    else {
                        console.warn(result.message);
                    }
                }
            };
            this.$fileDownloader.done(this._resultHanlder);
            //
            this._progressHandler = function (info) {
                if(self.loadState == 0) {
                    self.loadState = 1;
                }
                //
                self.loadFileName = info.fileName || self.loadFileName;
                self.loadedBytes = toFileSizeStr(info.loaded);
                self.totalBytes = toFileSizeStr(info.total) || self.totalBytes;
            };
            this.$fileDownloader.progress(this._progressHandler);
            //初始化下载信息版本
            this.infoVer = this.loadVer + 1;

            //
            if(this.autoDownload == true) {
                if(this.seqNo <= 0 && !this.xlsExport) {//不在下载组内 + 非纯xls导出
                    this.doDownload();
                }
            }
        },

        beforeDestroy() {
            if(this.$fileDownloader != null) {
                this.$fileDownloader.destroy();
                //
                this.$fileDownloader = null;
            }
            //
            this.header = null;
            this.params = null;
            this.data = null;
            this.onStarted = null;
            this.onResult = null;
        },
        //
        methods: {
            doClickDownload() {//手工点击下载专用
                if(this.clickable) {
                    this.doDownload();
                }
            },
            doDownload(valueAsNormalFormats) {//外部直调接口
                if(valueAsNormalFormats == true) {
                    this.valueAsNormalFormats = true;
                }
                //
                if(this.infoVer <= this.loadVer) {
                    let message = this.loadFileName + ' 已下载，无须重新下载';
                    if(typeof Toast !== 'undefined') {
                        Toast.show(message, 3000, 'warning');
                    }
                    else {
                        console.warn(message);
                    }
                    //
                    return;
                }
                //
                if(Utils.repeatChecker.isValidFor('FileDownload-ctrl', 1000)) {
                    this.loadVer = this.infoVer;
                    this.loadedBytes = this.totalBytes = null;
                    //
                    this.loadState = 1;
                    //
                    if(this.onStarted) {
                        let parent = this.parent || null;
                        this.onStarted.call(parent, this.seqNo);
                    }
                    //
                    let params = this.params || {};
                    if(this.valueAsNormalFormats == true) {
                        params['valueAsNormalFormats'] = true;
                    }
                    this.$fileDownloader.params(params);
                    //
                    this.$nextTick(function () {
                        this.$fileDownloader.go();
                    });
                }
            }
        }
    }

</script>


<style>
    .file-download {
        display: block;
        line-height: 32px;
        text-align: left;
        width: 100%;
        border: 1px dashed darkgray;
        padding: 4px;
    }

    .file-download .fileseq, .file-download .filename, .file-download .loadinfo, .file-download .stateinfo {
        display: inline-block;
    }

    .file-download .fileseq {
        color: #666;
        text-align: right;
        width: 34px;
        padding: 4px;
    }

    .file-download .filename {
        color: navy;
        margin: 0 4px;
        min-width: 100px;
    }

    .file-download .loadinfo {
        color: #666;
        width: 60px;
        font-size: 12px;
        margin-left: 4px;
        margin-right: 20px;
        text-align: right;
    }

    .file-download .stateinfo {
        margin-top: 4px;
    }

    .file-download .stateinfo .icon-xiajia {
        color: #777777;
    }

    .file-download .stateinfo .icon-xiajia.clickable {
        color: #007fff;
        cursor: pointer;
    }

    .file-download .stateinfo .icon-loading {
        width: 20px;
        height: 20px;
        margin-top: -2px;
    }

    .file-download .stateinfo .icon-success {
        color: #009900;
    }

    .file-download .stateinfo .icon-error {
        color: #e4393c;
    }
</style>



// WEBPACK FOOTER //
// src/compo/ctrl/FileDownload.vue